import { groupBy } from "lodash";
import formatTimeSpan from "~/filters/formatTimeSpan";
import { dayjs } from "~/utils/dayjs";

export function getConflictResolution(stayEvents, conflicts) {
  const options = [createOption(stayEvents, "delete:stayEvents"), createOption(conflicts, "delete:conflicts")];
  const newStayEventTimes = getStayEventSafeTimes(stayEvents, conflicts);
  const newConflictTimes = getStayEventSafeTimes(conflicts, stayEvents);

  const timeTypes = [
    { times: newStayEventTimes.startTime, value: "update:stayEvent:startTime" },
    { times: newStayEventTimes.endTime, value: "update:stayEvent:endTime" },
    { times: newConflictTimes.startTime, value: "update:conflict:startTime" },
    { times: newConflictTimes.endTime, value: "update:conflict:endTime" },
  ];

  timeTypes.forEach(({ times, value }) => {
    if (Object.keys(times).length) {
      options.push(
        createOption(
          Object.values(times).flat(),
          value,
          Object.fromEntries(Object.entries(times).map(([newTime, stayEvents]) => [newTime, stayEvents.map((se) => se.hexdigest)]))
        )
      );
    }
  });

  return options;
}

function getStayEventSafeTimes(stayEvents, conflicts) {
  const newStartTimes = {};
  const newEndTimes = {};

  conflicts.forEach((c) => {
    const cStart = dayjs(c.startTime);
    const cEnd = dayjs(c.endTime);

    stayEvents.forEach((se) => {
      const seStart = dayjs(se.startTime);
      const seEnd = dayjs(se.endTime);
      const containsConflict = cStart.isBetween(seStart, seEnd) && cEnd.isBetween(seStart, seEnd);
      const overlapsConflictStart = (seEnd.isSame(cEnd) || seEnd.isBetween(cStart, cEnd)) && seStart.isBefore(cStart);
      const overlapsConflictEnd = (seStart.isSame(cStart) || seStart.isBetween(cStart, cEnd)) && seEnd.isAfter(cEnd);

      if (containsConflict || overlapsConflictEnd) {
        const newStartTime = cEnd.format("HH:mm");
        if (newStartTimes[newStartTime]) {
          newStartTimes[newStartTime].push(se);
        } else {
          newStartTimes[newStartTime] = [se];
        }
      }

      if (containsConflict || overlapsConflictStart) {
        const newEndTime = cStart.format("HH:mm");
        if (newEndTimes[newEndTime]) {
          newEndTimes[newEndTime].push(se);
        } else {
          newEndTimes[newEndTime] = [se];
        }
      }
    });
  });

  return {
    startTime: newStartTimes,
    endTime: newEndTimes,
  };
}

function createOption(stayEvents, value, payload) {
  const groups = groupBy(stayEvents, "event.parentHexdigest");
  const names = Object.values(groups).map((g) => {
    const { event } = g[0];
    const { defaultStartTime, defaultEndTime, name } = event;
    return `${formatTimeSpan(defaultStartTime, defaultEndTime, "time")} ${name}`;
  });
  let label;

  switch (value) {
    case "delete:conflicts":
    case "delete:stayEvents":
      label = "Fjern deltagelser på " + names.join(", ");
      break;
    case "update:conflict:startTime":
    case "update:stayEvent:startTime":
      label = "Tilpas starttid på " + names.join(", ");
      break;
    case "update:conflict:endTime":
    case "update:stayEvent:endTime":
      label = "Tilpas sluttid på " + names.join(", ");
      break;
  }

  return {
    value,
    label,
    payload: payload || stayEvents.map((se) => se.hexdigest),
  };
}
